import { api } from "@/lib/api";
import { STAGES } from "@/lib/charts";

export function nextStage(app, wsEnabled) {
  const order = STAGES.map(([k]) => k);
  const i = order.indexOf(app.stage || "onboard");
  return i >= 0 && i < order.length - 1 ? order[i + 1] : null;
}

export const actions = {
  advance: (app, stage) => api.post("/applications/move", { application_ids: [app.id], stage }),
  assessmentLink: (app) => api.post(`/jobs/${app.job_id}/assessments/links`, { application_ids: [app.id] }),
  sendAssessment: (app) => api.post(`/jobs/${app.job_id}/assessments/send`, { application_ids: [app.id] }),
  sendWorkSample: (app) => api.post(`/jobs/${app.job_id}/work-samples/send`, { application_ids: [app.id] }),
  skipWorkSample: (app, reason) => api.post(`/applications/${app.id}/work-sample/skip`, { reason }),
  prepareInterview: (app) => api.post(`/applications/${app.id}/interview/prepare`),
};
